export default{
  NewUserGroupAdd: 'New User Group Add',
  UserGroupRemoved: 'User Group Removed',
  UserGroupUpdate: 'User Group Update',


  GroupName:'Group Name',
  Order: 'Order',
  Slug: 'Slug',
  Enable: 'Enable',
  Disable: 'Disable'
}